/* eslint-disable react-hooks/exhaustive-deps */
import { createContext, useEffect, useState, useContext } from "react";
import { ethers, providers, utils } from "ethers";
import WalletConnectProvider from "@walletconnect/web3-provider";
import QRCodeModal from "@walletconnect/qrcode-modal";
import toast from "react-hot-toast";

import useDidMountEffect from "../../hooks/useDidMountEffect";

import Context from "../User";
import ConnectWalletModal from "../../../components/ConnectWalletModal";
import { initWeb3State } from "../../constants";

export const WalletContext = createContext();
const { ethereum } = window;

export const WalletProvider = ({ children }) => {
  const { globalState } = useContext(Context);
  const [web3, setWeb3] = useState(initWeb3State);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [connectWalletModal, setConnectWalletModal] = useState(false);

  function isMobileDevice() {
    return "ontouchstart" in window || "onmsgesturechange" in window;
  }

  useEffect(() => {
    if (ethereum?.selectedAddress) {
      connectWalletWalletConnect(true);
      updateNetWork();
    } else {
      const provider = new WalletConnectProvider({
        rpc: {
          [process.env.REACT_APP_CHAIN_ID]: process.env.REACT_APP_CHAIN_RPC_URL,
        },
        bridge: "https://bridge.walletconnect.org",
      });
      if (provider.connected) {
        connectWalletConnect([], provider);
      } else {
        setLoading(false);
      }
    }
  }, []);

  useEffect(() => {
    const getWeb3 = async () => {
      try {
        const provider = new ethers.providers.Web3Provider(ethereum);
        const netWork = await provider.getNetwork();

        if (netWork.chainId !== Number(process.env.REACT_APP_CHAIN_ID)) {
          setErrorMessage(
            "This system support Theta Chain Only /b Invalid Network"
          );

          return;
        }
      } catch (error) {
        console.log(error);
      }
    };

    if (ethereum && ethereum.selectedAddress) {
      getWeb3();

      if (
        ethereum?.selectedAddress?.toLowerCase() !==
        globalState.user?.address?.toLowerCase()
      ) {
        setLoading(false);
        setErrorMessage("This is not the address you have been registered");
        return;
      }
      const provider = new ethers.providers.Web3Provider(ethereum);

      provider.getNetwork().then(({ chainId }) => {
        if (chainId !== Number(process.env.REACT_APP_CHAIN_ID)) {
          setErrorMessage(
            "This system support Theta Chain Only /b Invalid Network"
          );

          setLoading(false);
        } else {
          Promise.all([
            provider.getBalance(ethereum.selectedAddress),
            getContract("/abi/PresaleV2.json"),
            getContract("/abi/BULTToken.json"),
            getContract("/abi/AffiliateCommissions.json"),
          ]).then(
            ([
              balance,
              presaleContract,
              bulttContract,
              affiliateCommissionContract,
            ]) => {
              setWeb3({
                ...web3,
                contracts: {
                  bultToken: {
                    ...web3.contracts.bultToken,
                    contract: bulttContract,
                  },
                  presale: {
                    ...web3.contracts.presale,
                    contract: presaleContract,
                  },
                  affiliateCommissions: {
                    ...web3.contracts.affiliateCommissions,
                    contract: affiliateCommissionContract,
                  },
                },
                account: {
                  ...web3.account,
                  balance: Number(utils.formatUnits(balance)).toFixed(4),
                },
              });
              setLoading(false);
            }
          );
        }
      });
    } else {
      if (!ethereum) {
        setErrorMessage("install metamask  /b install metamask");

        setLoading(false);
        return;
      }
    }
  }, []);

  const getContract = async (url, walletConnectProvider) => {
    if (ethereum || walletConnectProvider.accounts.length) {
      try {
        const contractFile = await fetch(url);
        const convertContractFileToJson = await contractFile.json();

        const abi = convertContractFileToJson.abi;
        const networkObject =
          convertContractFileToJson.networks[       
            process.env.REACT_APP_CHAIN_ID ||
            parseInt(ethereum?.networkVersion, 16) ||
              walletConnectProvider?.chainId
          ];
        const contractAddress = networkObject?.address;

        const provider = new ethers.providers.Web3Provider(
          walletConnectProvider || ethereum
        );
        const signer = provider.getSigner();
        return new ethers.Contract(contractAddress, abi, signer);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const updateNetWork = async (chainId) => {
    try {
      await ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [
          {
            chainId: `0x${Number(process.env.REACT_APP_CHAIN_ID).toString(16)}`,
          },
        ],
      });

      if (chainId) {
        connectWalletWalletConnect(true);
      }
    } catch (error) {
      try {
        await ethereum.request({
          method: "wallet_addEthereumChain",
          params: [
            {
              chainName: process.env.REACT_APP_CHAIN_NAME,
              chainId: `0x${Number(process.env.REACT_APP_CHAIN_ID).toString(
                16
              )}`,
              rpcUrls: [process.env.REACT_APP_CHAIN_RPC_URL],
              nativeCurrency: {
                name: process.env.REACT_APP_CHAIN_CURRENCY_SYMBOL,
                symbol: process.env.REACT_APP_CHAIN_CURRENCY_SYMBOL,
                decimals: 18,
              },
              blockExplorerUrls: [
                process.env.REACT_APP_CHAIN_BLOCK_EXPLORER_URL,
              ],
            },
          ],
        });
      } catch (error) {
        console.log(error);
      }
      const errors = {
        4902: "Unrecognized chain ID Try adding the chain using wallet_addEthereumChain first.",
      };
      setLoading(false);
      console.log(error, errors[error.code]);
    }
  };

  const connectWalletWalletConnect = async (
    key,
    walletConnectProvider,
    walletConnectAddress
  ) => {
    setConnectWalletModal(false);
    if (isMobileDevice() && !ethereum) {
      window.open(
        `https://metamask.app.link/dapp/${
          window.location.origin.split("//")[1]
        }`
      );
    }

    if (!ethereum && !walletConnectProvider) {
      setErrorMessage("install metamask  /b install metamask");
      window.open("https://metamask.io/download.html", "_blank");

      return;
    }

    const provider = new providers.Web3Provider(
      walletConnectProvider || ethereum
    );
    let netWork = {
      chainId: 0,
    };

    if (walletConnectProvider) {
      netWork.chainId = provider.provider.wc.chainId;
    } else {
      netWork = await provider.getNetwork();
    }

    if (
      netWork.chainId &&
      netWork.chainId !== Number(process.env.REACT_APP_CHAIN_ID)
    ) {
      setErrorMessage(
        "This system support Theta Chain Only /b Invalid Network"
      );

      updateNetWork();
      if (walletConnectProvider) {
        try {
          await provider.disconnect();
        } catch (error) {
          console.log(error);
        }
      }
      return;
    }

    if (ethereum?.selectedAddress) {
      if (
        ethereum.selectedAddress?.toLowerCase() !==
        globalState.user?.address?.toLowerCase()
      )
        return setErrorMessage(
          "This is not the address you have been registered"
        );
    }

    if (walletConnectProvider?.accounts.length) {
      if (
        walletConnectProvider.accounts[0]?.toLowerCase() !==
        globalState.user?.address?.toLowerCase()
      )
        return setErrorMessage(
          "This is not the address you have been registered"
        );
    }

    try {
      setLoading(true);

      const account = {
        address: "",
        balance: "",
        walletConnectProvider: walletConnectProvider,
      };
      if (!walletConnectProvider) {
        const result = await ethereum.request({
          method: "eth_requestAccounts",
        });

        if (
          result[0]?.toLowerCase() !== globalState.user?.address?.toLowerCase()
        ) {
          setErrorMessage("This is not the address you have been registered");

          setLoading(false);
          return;
        }

        account.address = result[0]?.toLowerCase();
      } else {
        account.address = walletConnectAddress?.toLowerCase();
      }

      try {
        const presaleContractAPI = await getContract("/abi/PresaleV2.json", walletConnectProvider);
        const bulttContractAPI = await getContract("/abi/BULTToken.json", walletConnectProvider);
        const affiliateCommissionContractAPI = await getContract("/abi/AffiliateCommissions.json", walletConnectProvider);
        const balance = await provider.getBalance(walletConnectAddress || ethereum.selectedAddress);
       
        account.balance = Number(utils.formatUnits(balance)).toFixed(4);
        setWeb3({
          ...web3,
          account: {
            ...web3.account,
            ...account,
          },
          contracts: {
            bultToken: {
              ...web3.contracts.bultToken,
              contract: bulttContractAPI,
            },
            presale: {
              ...web3.contracts.presale,
              ...(key ? { contract: presaleContractAPI } : {}),
            },
            affiliateCommissions: {
              ...web3.contracts.affiliateCommissionContract,
              contract: affiliateCommissionContractAPI,
            },
          },
        });
      } catch (error) {
        console.log(error);
      }

      setErrorMessage("");
    } catch (error) {
      const errors = {
        "-32002": error.message,
        4001: "You have rejected the request.",
      };
      setErrorMessage(errors[error.code]);
      setLoading(false);

      console.log(error);
    }
  };

  const connectWalletConnect = async (account, providerState) => {
    setErrorMessage("");
    setConnectWalletModal(false);

    const provider =
      providerState ||
      new WalletConnectProvider({
        qrcodeModal: QRCodeModal,
        qrcode: true,
        rpc: {
          [process.env.REACT_APP_CHAIN_ID]: process.env.REACT_APP_CHAIN_RPC_URL,
        },
        bridge: "https://bridge.walletconnect.org",
        qrcodeModalOptions: {
          desktopLinks: ["metamask"],
        },
      });

    if (account?.[0])
      return connectWalletWalletConnect(false, provider, account[0]);

    let address;
    try {
      address = await provider.enable();
    } catch (error) {
      setErrorMessage("You have rejected the request.");
      return setLoading(false);
    }

    connectWalletWalletConnect(true, provider, address?.[0]);

    provider.on("accountsChanged", (accounts) => {
      if (
        accounts[0].toLowerCase() !== globalState.user?.address.toLowerCase()
      ) {
        setErrorMessage("This is not the address you have been registered");
        setWeb3(initWeb3State);
        provider.disconnect();
      } else {
        setErrorMessage("");
        connectWalletConnect();
      }
    });

    provider.on("chainChanged", async (chainId) => {
      if (parseInt(chainId, 16) !== Number(process.env.REACT_APP_CHAIN_ID)) {
        setErrorMessage(
          "This system support Theta Chain Only /b Invalid Network"
        );

        setLoading(false);
        await provider.disconnect();
      } else {
        await updateNetWork(chainId);
      }
    });

    provider.on("disconnect", () => {
      setErrorMessage("");
      setWeb3(initWeb3State);
    });
  };

  useDidMountEffect(() => {
    const { contract: presaleContract } = web3.contracts.presale;
    const { contract: bultTokenContract } = web3.contracts.bultToken;

    const getContractData = async () => {
      setLoading(true);

      const contractData = {
        claimer: null,
        min: "",
        max: "",
        remainingPresaleTotalSupply: "",
        tokenPrice: "",
        stopPresale: true,
      };

      const bultTokenContractData = {
        balance: "",
      };

      try {
        contractData.claimer = await presaleContract.getClaimer();
      } catch (error) {
        console.log(error);
        toast.error("We found an error try again or contact with support");
      }

      try {
        bultTokenContractData.balance = await bultTokenContract.balanceOf(
          web3.account.address || ethereum.selectedAddress
        );
      } catch (error) {
        console.log(error);
      }

      setWeb3({
        ...web3,
        contracts: {
          ...web3.contracts,
          bultToken: {
            ...web3.contracts.bultToken,
            data: bultTokenContractData,
          },
          presale: {
            ...web3.contracts.presale,
            data: contractData,
          },
        },
      });
      setErrorMessage("");
      setLoading(false);
    };

    web3.contracts.presale.contract &&
      !web3.contracts.presale.data.claimer &&
      getContractData();
  }, [web3.contracts.presale.contract]);

  useEffect(() => {
    if (!ethereum) return;

    ethereum.on("accountsChanged", async (acc) => {
      if (acc.length === 0) {
        setWeb3(initWeb3State);
        setErrorMessage("");
        setLoading(false);

        return;
      } else if (
        acc[0].toLowerCase() !== globalState.user?.address.toLowerCase()
      ) {
        setErrorMessage("This is not the address you have been registered");
        setWeb3(initWeb3State);
      } else {
        setLoading(true);
        connectWalletWalletConnect(acc);
      }
    });

    ethereum.on("chainChanged", async (chainId) => {
      if (parseInt(chainId, 16) !== Number(process.env.REACT_APP_CHAIN_ID)) {
        setErrorMessage(
          "This system support Theta Chain Only /b Invalid Network"
        );

        setLoading(false);
      } else {
        await updateNetWork(chainId);
      }
    });

    ethereum.on("disconnect", () => {
      setErrorMessage("");
      setWeb3(initWeb3State);
      console.log("disconnect", ethereum.selectedAddress);
    });
  }, []);

  const connectWallet = () => setConnectWalletModal(true);

  return (
    <WalletContext.Provider
      value={{
        web3,
        connectWallet,
        loading,
        setWeb3Loading: setLoading,
        errorMessage,
        setWeb3,
      }}
    >
      {connectWalletModal && (
        <ConnectWalletModal
          setConnectWalletModal={setConnectWalletModal}
          connectWalletWalletConnect={connectWalletWalletConnect}
          connectWalletConnect={connectWalletConnect}
        />
      )}
      {children}
    </WalletContext.Provider>
  );
};
